module.exports = __webpack_public_path__ + "static/media/002.610f2f51.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/totoro/002.gif
// module id = 835
// module chunks = 0